export const descriptionFieldTransform = (str: string = '-') => (str.length > 64 ? str.slice(0, 64) + '...' : str);
